import React from "react";
import styled from "styled-components";
import {CheckCircleOutlined, CloseCircleOutlined, SyncOutlined} from "@ant-design/icons";
import {Tag} from "antd";
import {useTranslation} from "react-i18next";

const StyledTag = styled(Tag)`
    min-width: 95px;
`;

export const StatusTag = ({status}) => {
    const {t} = useTranslation("shiftSuggestion");
    const statuses = {
        approved: {
            color: "success",
            icon: <CheckCircleOutlined />
        },
        rejected: {
            color: "error",
            icon: <CloseCircleOutlined />
        },
        processing: {
            color: "processing",
            icon: <SyncOutlined spin />
        }
    };

    if (!statuses[status]) {
        return <></>;
    }

    return (
        <StyledTag color={statuses[status].color} icon={statuses[status].icon}>
            {t(status, {ns: "shiftSuggestion"})}
        </StyledTag>
    );
};
